<template>
  <dv-border-box-13 class="bayes-classifier" style="display:flex;box-sizing:border-box;padding:2em;">
      <dv-border-box-12 class="" style="padding:1em 0em" :dur="5">
          <div class="dataV-box">
            <help :help_msg="help_info.header_help"></help>
            <select style="font-size:15px;margin:1em;width:100px" v-model="sample_name">
              <option
                v-for="(v,key,idx) in cls_list"
                :key="idx"
                :value="key"
              >{{v.name}}</option>
          </select>
            <!-- <dv-decoration-3 style="width:100px;height:30px;display:inline-block;margin-top:1em" /> -->
            <table-img style="margin-left:1em;" :data="data"  @click_pic="pic_deal"></table-img>
            <!-- <dv-decoration-3 style="flex:1;height:30px;min-width:50px" /> -->
            <div style="flex:1;height:30px;min-width:50px"></div>
          </div>
       </dv-border-box-12>

       <dv-border-box-12>
           <div class="dataV-box">
               <help :help_msg="help_info.editor_help" :style_str="'top:10px;'"></help>
               <!-- <div class="left_side_bar">
                   <button>二值图</button>
                   <button>数字化</button>
               </div> -->
               <edit-table-canvas :editable='0' :data="current_data.data" :data_title="'样本数据'"> </edit-table-canvas>
                <div class="left_side_bar">
                    <button @click="clone_left">克隆左侧</button>
                    <button @click="add_train">添加到样本</button>
                   
                   <button @click="add_new_to_bayes_table">添加识别</button>
                   <button @click="classify_data">分类识别</button>
                   <select v-model="classify_mode" style="min-width:45px;">
                       <option value="naive_bayes">朴素贝叶斯</option>
                       <option value="naive_bayes_lps">朴素贝叶斯-拉普拉斯优化</option>
                   </select>
               </div>
               
                <edit-table-canvas :editable='3' :data="new_data" :data_title="'待分类数据'"> </edit-table-canvas>
           </div>
       </dv-border-box-12>
            
      <dv-border-box-12 style="display:flex;box-sizing:border-box;padding:2em">
          <div class="dataV-box">
              <help :help_msg="help_info.table_help" :style_str="'top:-6px;right:-15px'"></help>
              <div class="left_side_bar">
                  <button @click="table_switch(1)">特征表</button>
                  <button @click="table_switch(2)">概率表</button>
                  <!-- <dv-border-box-7 class="btn">特征表</dv-border-box-7><dv-border-box-7 class="btn">概率表</dv-border-box-7> -->
              </div>
            
              <div style="max-width:100%;over-flow:auto" id="result_table">
                <array-table
                    :data="table_show_data" 
                    :head="feature_data_head" 
                    :cell_width="cell_width" 
                    :config="{title_mode:'value'}"
                    @cellEnter="cell_enter"
                ></array-table>
                <!-- <array-table  :data="table_show_data2" :cell_width="cell_width"></array-table> -->

              </div>

          
                <!-- <my-table :table_style="table_style" :data="flat_data" :update="update_idx"></my-table> -->

         </div>

      </dv-border-box-12>


  </dv-border-box-13>
</template>

<script>
import {sample_list} from '~js/bayes_classifier.js';
import NameArray from './NameArray.vue';
import MyTable from './table/MyTable.vue';
import TableImg from './table/TableImg.vue';
import {obj_copy} from '~pjs/xfl_tool.esm.js';
import {array_like} from '~pjs/xfl_math.esm.js';

import EditTableCanvas from './table/EditTableCanvas.vue';
import ArrayTable from './table/com/ArrayTable.vue';

import {msgbox} from '~js/smallarAlert.esm.js';//特用的，不要从公共js库中取
import Help from './Help.vue';
import {help_info} from '~js/help_info.js';

// let cls_list = JSON.parse(JSON.stringify(sample_list));
// console.log(cls_list);

let table_style ={
    head_title_width:'30px',
    head_height:'30px',
    grid_width:'20px',
    grid_height:'20px',
    table_width:'300px'

}

export default {
    name:'BayesClassifier',
    mounted() {        
         
         this.cls_list = JSON.parse(JSON.stringify(sample_list));
         this.sample_list = {...Object.keys(this.cls_list)};
         //this.$nextTick(()=>this.sample_name = this.sample_list[0]);
         this.update_data();
        // console.log(Object.keys(cls_list));
        // console.log(this.sample_list);

    },
    data(){
        return {
            //table_style:table_style,
            help_info:help_info,
            cls_list:{},    //总数据
            sample_name:'xyz',
            data_path:[],   //数据路径 [tag,sub_tag]
            current_data:{},//当前数据，{tag:'',sub_tag:'',data:data}}
            tag_data:{},    //tag_data 标签数据集,添加到表中的
            bayes_data:{},  //tag data 统计数据
            feature_nums:0, //数据的特征数量，最后一个add_data的数
            //tag_data_dealed:{},//标签数据中添加了统计信息的数据
            feature_data_array:[[]],//特征表中显示的数据
            feature_data_head:[],

            bayes_data_array:[[]],//显示带统计的特征数据集
            bayes_data_array_simple:[[]],//仅带统计的数据
            data_num:0,//样品数量,在计算bayes_data_array_simple的时候计算
            sum_PB:0,//属性全概率和,在计算bayes_data_array_simple时计算
            bayes_data_head:[],//数据表头

            table_show_data:[],// 0-显示特征数据集 1 - 显示带统计的特征数据集 2- 仅带统计的特征集
            table_show_data2:[],// 0-显示特征数据集 1 - 显示带统计的特征数据集 2- 仅带统计的特征集

            new_data:[[]],//将显示在右侧新增数据区

            flat_data:{},
            result_head_array:['值','特征计算值和','距离','分类结果'],
            detail_data:[[]],//显示在图像数据表格中  data_path及detail_data表示当前数据

            new_data_path:[],//如果有path,代表添加到数据集中用来训练数据, 如果无path代表要用来识别分类
            bayes_result_data:[[]],//结果数据
            cell_width:'20px',//表格宽度

            classify_mode:'naive_bayes',

            data:{}
            // data:{
            //     "x":[1,0,0,0,1, 0,1,0,1,0, 0,0,1,0,0, 0,1,0,1,0, 1,0,0,0,1],
            //     "y":[1,0,0,0,1, 0,1,0,1,0, 0,0,1,0,0, 0,1,0,0,0, 1,0,0,0,0],
            //     "z":[1,1,1,1,1, 0,0,0,1,0, 0,0,1,0,0, 0,1,0,0,0, 1,1,1,1,1],
            // }
        }
    },
    methods: {
        add_train(){
            let input_select ='已有类别<select id="msg_select"> style="width:40px"';
            let last_i;
            for(let i in this.tag_data){
                input_select += `<option value=${i}>${i}</option>`;
                last_i = i;
            };
            input_select += '</select><br>加入类别<input id="msg_input" title="可输入自定义类别" type="text" placeholder="自定义标签" value='+ (this.last_add_tag||last_i) + '>';

            let data = this.new_data;
            msgbox({
                type:'confirm',
                title:'数据标签选择',
                msg:'请设置当前数据添加到哪一类标签下:<br>' + input_select,
                yes_txt:'确定',
                no_txt:'取消',
                lazy_exit:true,
                callback:()=>{
                    if( $('#msg_input').length==0){console.warn('No input fond why?');return;}
                    let tag = $('#msg_input').val().toString().trim();
                    if(tag!=''){
                        this.last_add_tag = tag;
                        if(!this.data[tag])this.data[tag] ={};
                        let sub_tag = 'custom_' + Object.keys(this.data[tag]).length;
                        this.data[tag][sub_tag] = data;
                        this.pic_deal([tag,sub_tag]);
                    }
                }
            });
            if(this.last_add_tag)$('#msg_select').val(this.last_add_tag);
            $('#msg_select').change(()=>{$('#msg_input').val($('#msg_select').val())});


        },
        add_PB_cacl(){
            let PB_row = [];
            let unkown_data = this.new_data.flat();
            //PBi计算
            for(let i of unkown_data){

                PB_row.push([

                ])
            }

        },
        classify_data(){
            let mode =  this.classify_mode;
            console.log('classify data with mode:' + mode);
            if(this.bayes_data_array_simple.length==0 || this.bayes_data_array_simple[0].length==0){
                console.warn('No classify data return!');
                return;
            };
            if(this.bayes_data_array_simple.length < (Object.keys(this.tag_data).length+1)){
                console.warn('No data feature added to bayes table');
                msgbox({
                    type:'pop',
                    title:'提示',
                    msg:'请先点击添加识别，把待分类数据加入到统计表格中',
                    show_time:800
                })
                return;
            };

            let unkown_data = this.new_data.flat();

            

            let total_data_num = this.feature_data_array.length;
            let start_row_idx = Object.keys(this.tag_data).length+2+1 ;//+1 为特征数据 +2 开始放P(A|Bi)  中间添加一行为PB的计算，同时再空一格
            //在上行添加数据
            let len = this.bayes_data_array_simple[0].length;

            // this.$set(this.bayes_data_array_simple[start_row_idx-1],len,'P(A)');
            // this.$set(this.bayes_data_array_simple[start_row_idx-0],len,'P(A|B)');
            //this.bayes_data_array_simple[start_row_idx-1][len]='P(A|B)';
            let tag_idx=0;
            let for_normalize ={};
            let has_zero = 0;
            let class_nums= Object.keys(this.tag_data).length;
            for(let tag in this.tag_data){   //
                let tag_row = 0;   //当前类个数 
                let tag_data_sum;  //特征和数据      
                for(let sub_tag in this.tag_data[tag]){
                    tag_row ++ ;
                    let row = this.tag_data[tag][sub_tag].flat();
                    if(!tag_data_sum)tag_data_sum = new Array(row.length).fill(0);
                    for(let k=0,len=row.length;k<len;k++)tag_data_sum[k]+=row[k];
                    //res.push(row)
                };


               // res[start_row_idx].unshift([tag,'r'+tag_row]);

                //统计概率
                let multiply_chain = 1; //连乘
                let types_num = 2;//class_nums;//2;
                let tag_zero = 0; //当前特征中0的个数
                //第一遍 统计0个数
                tag_data_sum.map((v,idx,arr)=>{
                    let v1= unkown_data[idx]==1 ?v/tag_row:(tag_row-v)/tag_row;
                    if(v1<=1e-8)tag_zero++;
                });
                //第二遍，优化添加计算
                tag_data_sum.map((v,idx,arr)=>{
                    // if(unkown_data[idx]==1){
                    //     arr[idx] = mode!=='naive_bayes' && tag_zero>0 ?[`${v+1}/${tag_row+types_num*tag_zero}`,`P(B${idx+1}|A${tag}):${v}/${tag_row} 拉普拉斯优化:(${v}+1)/(${tag_row}+${types_num}*${tag_zero})`]:[`${v}/${tag_row}`,`计算过程P(B${idx+1}|A${tag}):${v}/${tag_row}`];
                    // }else{
                    //     arr[idx] = mode!=='naive_bayes' && tag_zero>0?[ `${tag_row - v + 1}/${tag_row + types_num*tag_zero}`,`P(B${idx+1}|A${tag}):(${tag_row}-${v})/${tag_row} 拉普拉斯优化:(${tag_row}-${v}+1)/(${tag_row}+${types_num}*${tag_zero})`]: [`${tag_row - v}/${tag_row}`,`计算过程P(B${idx+1}|A${tag}):(${tag_row}-${v})/${tag_row}`];
                    // };
                    let v1= unkown_data[idx]==1 ?v/tag_row:(tag_row-v)/tag_row;
                    if(unkown_data[idx]==1){
                        arr[idx] = mode!=='naive_bayes' && v1==0 ?
                        [`${v+1}/${tag_row+types_num}`,`P(B${idx+1}|A${tag}) = ${v}/${tag_row} 拉普拉斯优化:(${v}+1)/(${tag_row}+${types_num})`]:
                        [`${v}/${tag_row}`,
                        `P(B${idx+1}|A${tag}) = ${v}/${tag_row}`];
                    }else{
                        arr[idx] = mode!=='naive_bayes' && v1==0?
                        [ `${tag_row - v + 1}/${tag_row + types_num}`,`P(B${idx+1}|A${tag})=(${tag_row}-${v})/${tag_row} 拉普拉斯优化:(${tag_row}-${v}+1)/(${tag_row}+${types_num})`]:
                        [`${tag_row - v}/${tag_row}`,`P(B${idx+1}|A${tag})=(${tag_row}-${v})/${tag_row}`];
                    };
                    let this_v = eval(arr[idx][0])
                    multiply_chain *= this_v;
                });
                has_zero += tag_zero;
                // tag_data_sum.unshift( `P(A${tag}|Bi)`);
                tag_data_sum.unshift( [`P(Bi|A${tag})`,`先验概率种类${tag}中特征Bi==1的概率`]);
                //添加背景
                // tag_data_sum.forEach(v=>{
                //     if(Array.isArray(v) && v.length==2)v[2]='style:background:#788181';
                // })
                let PAj = mode !=='naive_bayes' && tag_zero>0? [`${tag_row + 1*tag_zero }/${this.sample_nums + this.class_nums*tag_zero}`,`种类${tag}占比P(A${tag}):${tag_row}/${this.sample_nums} 拉普拉斯优化:(${tag_row}+1*${tag_zero})/(${this.sample_nums}+${class_nums}*${tag_zero})`]:[`${tag_row}/${this.sample_nums}`,`种类${tag}占比P(A${tag}):${tag_row}/${this.sample_nums}`];

                for_normalize[tag] = [start_row_idx+tag_idx,multiply_chain,PAj,tag_zero];//位置 PBi|Ax连乘 P(Ax)

                // if(PBA_result[0]<0.001)PBA_result[0] = PBA_result[0].toExponential(2);
                //tag_data_sum.push(PA,PBA_result);//整体都除以了全概率PB
                this.$set(this.bayes_data_array_simple,start_row_idx+tag_idx,tag_data_sum);
                tag_idx++;

                
            };
 
        
            this.$set(this.bayes_data_array_simple,start_row_idx,this.bayes_data_array_simple[start_row_idx]);//主动通知

            //PAj计算 修正for循环内计算
            for(let tag in for_normalize){
                let tag_row = this.get_tag_nums(tag);
                let tag_zero = has_zero; //总零处数
                for_normalize[tag][2] =  mode !=='naive_bayes' && has_zero>0? [`${tag_row + 1*tag_zero }/${this.sample_nums + this.class_nums*tag_zero}`,`种类${tag}占比P(A${tag}):${tag_row}/${this.sample_nums} 拉普拉斯优化:(${tag_row}+1*${tag_zero})/(${this.sample_nums}+${class_nums}*${tag_zero})`]:[`${tag_row}/${this.sample_nums}`,`种类${tag}占比P(A${tag}):${tag_row}/${this.sample_nums}`];
            }


            let PB_row_idx = start_row_idx + tag_idx + 1;
            let PB_row = [['P(Bi)','所有样本中特征等于待分类特征的概率'],1,2,3,4]; //PB概率计算
            let PB_chain = 1; //PB连乘
            //PB计算
            for(let i=0,len=this.feature_nums;i<len;i++){
                let pb_v=0,pb_tag=[],tag_idx=0;
                for(let tag in for_normalize){
                    pb_tag.push(`P(B${1+i}|A${tag})*P(A${tag})`);
                    let tag_num = this.get_tag_nums(tag);
                    //              P(Bi|Aj) * P(Aj)
                    pb_v +=   eval(this.bayes_data_array_simple[start_row_idx+tag_idx][i+1][0])* eval(for_normalize[tag][2][0]);
                    tag_idx++;
                }
                 
                PB_row[i+1] = [
                    pb_v,
                    `P(B${i+1})= ${pb_tag.join('+')}=${pb_v}`
                ];
                PB_chain *= pb_v;
            }
            // this.$set(this.bayes_data_array_simple,PB_row_idx,[['P(B)','c'+this.feature_nums+1],'text-align:left']);
            this.$set(this.bayes_data_array_simple,PB_row_idx,PB_row);

            //计算P(Aj) 以及 P(B|Aj)
            let PAj_row_idx = PB_row_idx + 2;
            let tag_idx2 = 0;
            for(let tag in this.tag_data){
                let paj_row = [[`P(A${tag})`,`种类${tag}在总样本中的占比`],[],[`P(B|A${tag})`,`在种类${tag}中出现组合B的概率`,'c2'],[]];
                // let tag_num = this.get_tag_nums(tag);
                // let PA = mode=='naive_bayes'? [`${tag_num}/${this.sample_nums}`,`种类${tag}占比P(A${tag}):${tag_num}/${this.sample_nums}`]:[`${tag_num + 1 }/${this.sample_nums + this.class_nums}`,`种类${tag}占比P(A${tag}):${tag_num}/${this.sample_nums} 拉普拉斯优化:(${tag_num}+1)/(${this.sample_nums}+${this.class_nums})`];
                paj_row[1] = [
                    for_normalize[tag][2][0],
                    for_normalize[tag][2][1],
                    // 'text-align:left',
                    'c'+(this.feature_nums/2),
                    // 'style:background:#788181;'
                ]
                paj_row[3] = [
                    for_normalize[tag][1],
                    `独立组合事件P(B|A${tag})=P(B1|A${tag})*P(B1|A${tag})*...P(B${this.feature_nums}|A${tag})=${for_normalize[tag][1]}`,
                    // 'text-align:left',
                    'c'+(this.feature_nums/2-1)
                ]
                this.$set(this.bayes_data_array_simple,PAj_row_idx+tag_idx2,paj_row);
                tag_idx2++;
            };
            
            //添加P(B)
            let PB_all_row = [
                ['P(B)','所有特征的概率均独立'],
                [PB_chain,`P(B)=P(B1)*P(B2)*...P(B${this.feature_nums})=${PB_chain}`,'c'+(this.feature_nums/2)],
                ['概率归一化','由于拉普拉斯优化操作可能导致各准确值发生变化，因此通常最后结果进行归一化操作','c' + (this.feature_nums+1 - parseInt(this.feature_nums/2))]
            ]
            this.$set(this.bayes_data_array_simple,PAj_row_idx+tag_idx2,PB_all_row);


            //计算P(Aj|B)
            let PBA_row_idx = PAj_row_idx + tag_idx2+1;
            tag_idx2 = 0;
            let sum_res = 0;
            let tag_str = [];
            let max_v=0,prob_tag;
            for(let tag in this.tag_data){
                let paj_row = [[`P(A${tag}|B)`,`在已知样本下,出现组合B是${tag}的概率`]];
                let val =  for_normalize[tag][1] * eval(for_normalize[tag][2][0]) /PB_chain;
                let calc_str = `P(A${tag}|B) = P(B|A${tag}) * P(A${tag}) / P(B)  注:P(B)相同,实际计算中通常可忽略`;
                tag_str.push( `P(A${tag}|B)`)
                paj_row[1] = [
                    val,
                    calc_str,
                    // 'text-align:left',
                    'c'+(parseInt(this.feature_nums/2))
                ]
                if(val>max_v){max_v=val;prob_tag=tag};
                sum_res += val;
                this.$set(this.bayes_data_array_simple,PBA_row_idx+tag_idx2,paj_row);
                tag_idx2++;
            };
            //P(Aj|B)归一化赋值
            tag_idx2 = 0;
            for(let tag in this.tag_data){
                let paj_row = this.bayes_data_array_simple[PBA_row_idx+tag_idx2];
                let val =  paj_row[1][0]/sum_res;
                let calc_str = `Normallize(P(A${tag}|B)) = P(B|A${tag})/(${tag_str.join('+')})`
                paj_row[2] = [
                    val,
                    calc_str,
                    // 'text-align:left',
                    'c'+(this.feature_nums + 1 - parseInt(this.feature_nums/2))
                ]
                if(prob_tag==tag)paj_row[2].push('style:color:green;')
                this.$set(this.bayes_data_array_simple,PBA_row_idx+tag_idx2,paj_row);
                tag_idx2++;
            };
            
            if(has_zero>0 && mode=='naive_bayes')
            setTimeout(()=>msgbox({
                type:'alert',
                title:'拉普拉斯优化提示',
                msg:'检测到有P(Bi|Aj)概率计算为0,朴素贝叶斯分类器无法原理上无法区分<br>请选择拉普拉斯优化模式进行识别<br>见贝叶斯理论部分公式5',
                yes_txt:'确定',
            }),500)

            this.update_ui();
              
        },
        cell_enter(par){
            console.log('mouseEnter',par);
            const PBiAj_idx = 1 + this.class_nums + 1 ;//
            const PBi = PBiAj_idx + this.class_nums + 1;
            const PA_res = PBi + 1 + 1;
            let show_row = -1,style="";
            switch(true){
                case par[1]>=PA_res:show_row = PA_res;style="style:background:#70a858;color:white;";break;
                case par[1]>=PBi:show_row = PBi;style="style:background:#709858;color:white;";break;
                case par[1]>=PBiAj_idx:show_row = PBiAj_idx;style="style:background:#708858;color:white;";break;
            }
            let col_span = 'c'+ this.sample_nums + 1;
            if(Array.isArray(par[0]) && show_row>=0 && par[0][1])this.$set(this.bayes_data_array_simple,show_row,[[par[0][1],'',col_span,style]]);

        },
        create_bayes_data(){
            let res = {};
            //统计总数

        },
        add_new_to_bayes_table(){
            let new_row = this.new_data.flat();
            new_row.unshift('待分类特征');
            //this.table_show_data2 = [new_row];
            let row = Object.keys(this.tag_data).length+1;
            // this.bayes_data_array_simple[row] = new_row;
            this.bayes_data_array_simple.splice(row,500); //del extra datas calced by classify
            this.$set(this.bayes_data_array_simple,row,new_row);
            this.$set(this.bayes_data_array_simple,row-1,[['','c'+new_row.length]]);
            this.table_switch(3);
        },
        clone_left(){
            if(!this.current_data.data){
                msgbox({
                    type:'pop',title:'提示',msg:'左侧无数据，请点击上方样品栏添加样品数据','show_time':800
                });
                return;
            }
            this.new_data = JSON.parse(JSON.stringify(this.current_data.data));
        },
        table_switch(idx){
           switch(idx){
               case 1:this.table_show_data = this.feature_data_array;this.cell_width='20px';break;
               case 2:{
                   if(this.table_show_data == this.bayes_data_array){
                       this.table_switch(3);
                   }else{
                       this.table_show_data = this.bayes_data_array;this.cell_width='25px';
                   }
                   break;
               }
               case 3:{
                   this.cell_width='40px';
                   this.table_show_data = this.bayes_data_array_simple;break;
               }
               default :console.log('not support');break;
           };
           this.update_ui();
        },
        update_ui(){
            this.$nextTick(()=>window.dispatchEvent(new Event('resize')));//重绘dataV
        },
        pic_deal(idx){
            console.log('pic_deal');
            if(!Array.isArray(idx)){console.warn('bad idx pars,should be array');return};
            this.data_path = idx;
            this.current_data = {tag:idx[0],sub_tag:idx[1],data:obj_copy(this.data[idx[0]][idx[1]])} ;

            //table css test
            // this.current_data.data[0][0] = [1,'','background-color:red;width:50px','自定义提示'];

            this.add_data(idx);
            this.feature_data_array = this.feature_data_to_array();
            this.feature_data_head = this.feature_data_to_head();
            this.bayes_data_array = this.feature_data_to_bayes_array();
            this.bayes_data_array_simple = this.feature_data_to_bayes_simple_array();
            this.table_show_data = this.feature_data_array;//

            this.$nextTick(()=>window.dispatchEvent(new Event('resize')));//重绘dataV
        },
        update_data(){
            console.log('update classifier data');
            let ori_data = obj_copy(this.cls_list[this.sample_name].data);
            this.tag_data ={};//清空tag_data
            this.data = {};
            this.flat_data={};

            this.new_data=[[]];
            let any_path = [];
            for(let i in ori_data){
                this.data[i] = ori_data[i];
                //this.flat_data[i] = ori_data[i].flat();
                any_path = i;
            };

            this.new_data = array_like(this.data[any_path][Object.keys(this.data[any_path])[0]]);

            this.$nextTick(()=>window.dispatchEvent(new Event('resize')));//重绘dataV

        },
        add_data(path){
     
                if(!this.tag_data[path[0]])this.tag_data[path[0]] = {};//添加数据
                this.tag_data[path[0]][path[1]] =this.data[path[0]][path[1]];
                this.feature_nums = this.tag_data[path[0]][path[1]].flat().length;
            

        },
        feature_data_to_array(){//依赖tag_data
            console.log('calc feature data array');
            let res = [];
 
            for(let tag in this.tag_data){   
                let tag_row = 0;    
                let start_row_idx = res.length;         
                for(let sub_tag in this.tag_data[tag]){
                    tag_row ++ ;
                    let row = this.tag_data[tag][sub_tag].flat();
                    res.push(row)
                };

                res[start_row_idx].unshift([tag,'r'+tag_row]);
            }
            return res;            
        },
        feature_data_to_head(){//类 1\2\3...35
            let data_len = this.current_data.data.flat().length;
            let head_row =['类别\\特征'];
            for(let i=0;i<data_len;i++)head_row.push((i+1));//生成头
            return head_row;
        },
        feature_data_to_bayes_array(){
            console.log('calc feature data bayes array');
            let res = [];
 
            for(let tag in this.tag_data){   
                let tag_row = 0;    
                let start_row_idx = res.length;
                let tag_data_sum;        
                for(let sub_tag in this.tag_data[tag]){
                    tag_row ++ ;
                    let row = this.tag_data[tag][sub_tag].flat();
                    if(!tag_data_sum)tag_data_sum = new Array(row.length).fill(0);
                    for(let k=0,len=row.length;k<len;k++)tag_data_sum[k]+=row[k];
                    res.push(row)
                };

                res[start_row_idx].unshift([tag,'r'+tag_row]);
 
                //统计概率
                tag_data_sum.map((v,idx,arr)=>{
                    arr[idx] = `${v}/${tag_row}`;
                });
                tag_data_sum.unshift('特征占比');
                res.push(tag_data_sum);

            }
            return res;   

        },
        feature_data_to_bayes_simple_array(){
            console.log('calc feature data bayes simple array');
            let res = [];
            this.data_num = this.tag_data_num();//总数据个数

            let PBi_n=0;//特征数
            let PB ={};
            for(let tag in this.tag_data){   
                let tag_row = 0;    
                let start_row_idx = res.length;
                let tag_data_sum;        
                for(let sub_tag in this.tag_data[tag]){
                    tag_row ++ ;
                    let row = this.tag_data[tag][sub_tag].flat();
                    PBi_n = row.length;
                    if(!tag_data_sum)tag_data_sum = new Array(row.length).fill(0);
                    for(let k=0,len=row.length;k<len;k++)tag_data_sum[k]+=row[k];
                    //res.push(row)
                };

               // res[start_row_idx].unshift([tag,'r'+tag_row]);

                //统计概率 P(Bi|A)
                tag_data_sum.map((v,idx,arr)=>{
                    arr[idx] = `${v}/${tag_row}`;
                });
                PB[tag] = [tag_row/this.data_num,obj_copy(tag_data_sum)];//P(A)类型概率 P(Bi|A)概率,某类属性出现的概率
                tag_data_sum.unshift( `P(Bi|A${tag})`);
                res.push(tag_data_sum);
            };

            this.sum_PB = 1;
            let each_PBA = new Array(PBi_n).fill(0);
            for(let i=0;i<PBi_n;i++){
                for(let tag in PB){
                    each_PBA[i] += PB[tag][0]*eval(PB[tag][1][i]);//PA * P(Bi|A) i+1是由于该行加入了说明性首列
                 }
            };
            each_PBA.map((v)=>{
                this.sum_PB *=v;
            });
            console.log('sum_PB:'+this.sum_PB);
            return res;   

        },
        tag_data_num(){//仅依赖tag_data变化 标签数据的数量
            console.log('tag data num calced');
            let res = 0;
            for(let tag in this.tag_data){
                res += Object.keys(this.tag_data[tag]).length;
            };
            return res;
        },
        get_data_max_len(obj){//属性:可能维array 统计array的长度
            let max_len=0;
            for(let i in obj){
                if(Array.isArray(obj[i])){//如果是数组,直接展平计算长度
                    let flat_row = obj[i].flat();
                    if(flat_row.length>max_len)max_len = flat_row.length;
                }else if (typeof obj[i]=='object'){//如果是对象,仍然往下发
                    let this_max_len = this.get_data_max_len(obj[i]);
                    if(this_max_len>max_len)max_len = this_max_len;
                }else{
                    return 0;
                }
            };
            return max_len;
        },
        get_tag_nums(tag){
            return Object.keys(this.tag_data[tag]).length
        }
    },

    computed:{
        class_nums(){
            return Object.keys(this.tag_data).length
        },
        sample_nums(){
            let n=0;
            for(let tag in this.tag_data){
                n+= Object.keys(this.tag_data[tag]).length;
            };
            return n;
        },
        // feature_nums(){//按最后一个添加的数据来计算

        // },
        tag_num(){//仅依赖tag_data变化 类别的数量
            console.log('tag num calced');
            return Object.keys(this.tag_data).length;
        },
        sub_tag_num(){//仅依赖tag_data变化 类别下 标签数据的数量
            console.log('calc sub tag num');
            let res ={};
            for(let tag in this.tag_data){
                res[tag] = Object.kyes(this.tag_data[tag]);
            };
            return res;
        },
        tag_data_PBi(){
            console.log('tag data PBi calced');
            let res ={};
            for(let tag in this.tag_data){
                let sub_tag_sum ;
                let row_data;
                for(let sub_tag in this.tag_data[tag]){
                    row_data = this.tag_data[tag][sub_tag].flat();
                    if(!sub_tag_sum) sub_tag_sum = new Array(row_data.length).fill(0);
                    sub_tag_sum.map((v,idx,arr)=>{
                        arr[idx] += row_data[idx]
                    });
                };
                res[tag] = sub_tag_sum;
            };
            return res;
        },

        tag_data_dealed(){
            console.log('tag data dealed');
            let res = obj_copy(this.tag_data);
 
            for(let tag in res){
                if(tag.startsWith('_'))continue;
                let tag_row = 0;    
                let tag_data_sum;        
                for(let sub_tag in res[tag]){
                    if(sub_tag.startsWith('_'))continue;
                    tag_row ++ ;
                    let row = res[tag][sub_tag].flat();
                    if(!tag_data_sum)tag_data_sum = new Array(row.length).fill(0);
                    for(let k=0,len=row.length;k<len;k++)tag_data_sum[k]+=row[k];
                    //res.push(row)
                };
                res[tag]['_N'] = tag_row; //数量

               // res[start_row_idx].unshift([tag,'r'+tag_row]);

                //统计概率
                tag_data_sum.map((v,idx,arr)=>{
                    arr[idx] = v/tag_row;
                });
                
                res[tag]['_B'] = tag_data_sum; //统计占比

            }
            return res;   

        },

 
        table_style(){
            let grid_width = 30 , grid_height = 30;
            let head_title_width = 50,head_height=30;
            let row_height = 30;
            let res ={
                table_width:(head_title_width + this.max_array_len*(grid_width+4)) + 'px',
                head_title_width:head_title_width+'px',
                head_height:head_height + 'px',
                grid_width:grid_width + 'px',
                grid_height:grid_height + 'px',
            };

            return res;
        }
    },
    watch: {
        sample_name(){
            console.log('sample name change to:' + this.sample_name);
            this.update_data();
            console.log(this.data);
            console.log(this.flat_data);       
    
        }
    },
    components:{
         
        NameArray,
        MyTable,
        TableImg,
        EditTableCanvas,
        ArrayTable,
        Help,
    }
}
</script>

<style lang="stylus" scoped>
@import "~css/mixins.styl"
@import '~css/dataV.styl'

.dataV-box
    display:flex;
    padding:0.5em;
    margin:0 auto;
    margin-bottom:10px;
    justify-content:center;
    align-items:center
    


.btn
    margin:4px 5px;
    btn_dataV()


.center
    center()
.bayes-classifier
    background-color:rgb(10,13,53)

.left_side_bar
    //padding:0px 10px;
    width:10%;
    display :flex;
    flex-direction:column;
    justify-content :space-around;
    align-items :center;

    & button
        margin:1em 0em;
        white-space :nowrap;
        width:60%;
    & select
        width:60%;
    & div 
        margin:1em 0em;
    
</style>
